import { createContext, useContext, useRef, useState, useCallback } from "react";

const SoundContext = createContext(null);

export const SoundProvider = ({ children }) => {
  const [enabled, setEnabled] = useState(true);
  const ctxRef = useRef(null);

  const pluck = useCallback(
    (freq = 196) => {
      if (!enabled) return;
      try {
        if (!ctxRef.current) ctxRef.current = new (window.AudioContext || window.webkitAudioContext)();
        const ctx = ctxRef.current;
        if (ctx.state === "suspended") ctx.resume();
        const t = ctx.currentTime;
        [1, 2, 3].forEach((h, i) => {
          const osc = ctx.createOscillator();
          const gain = ctx.createGain();
          osc.type = "triangle";
          osc.frequency.setValueAtTime(freq * h, t);
          gain.gain.setValueAtTime(0.08 / (i + 1), t);
          gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.6 - i * 0.1);
          osc.connect(gain).connect(ctx.destination);
          osc.start(t);
          osc.stop(t + 0.7);
        });
      } catch (e) {}
    },
    [enabled]
  );

  const toggle = () => setEnabled((v) => !v);

  return <SoundContext.Provider value={{ enabled, toggle, pluck }}>{children}</SoundContext.Provider>;
};

export const useSound = () => useContext(SoundContext);
